import styled from 'styled-components';

export const Wrapper = styled.div<{ size: number }>`
	display: flex;
	width: ${p => p.size}px;
	height: ${p => p.size}px;
	position: relative;
`;
